import { useState } from 'react';
import styled from 'styled-components';

import {
  CreativeLibraryPanel,
  ImageMetadata,
  PanelIntent,
  defaultImgMetadata,
} from 'modules/creativeLibrary';
import { SecondaryButton } from 'ui/button';
import { Image16 } from 'ui/icons/aurora/16px/Image16';
import { useNavBarHeight } from 'utils/hooks/useNavBarHeight';
import { useTranslation } from '../../../hooks/useTranslation';
import { useContentMetadata } from '../contexts/ContentMetadata';

const CreativeLibraryWrapper = styled.div<{ $navbarHeight: number }>`
  & > * {
    margin-top: ${({ $navbarHeight }) => $navbarHeight}px;
  }
`;

type ImagePickerButtonProps = {
  onSelectContent: (content: string) => void;
};

export const ImagePickerButton = ({ onSelectContent }: ImagePickerButtonProps) => {
  const { t } = useTranslation();
  const { setImageMetadata } = useContentMetadata();
  const [isShowing, setIsShowing] = useState(false);
  const navbarHeight = useNavBarHeight();

  const onClick = () => {
    setIsShowing(true);
  };

  const onClose = () => {
    setIsShowing(false);
  };

  const onSelect = (url: string, imgMetadata?: ImageMetadata) => {
    setIsShowing(false);
    onSelectContent(`<img src="${url}" />`);
    setImageMetadata(imgMetadata || defaultImgMetadata);
  };

  return (
    <div>
      {isShowing && (
        <CreativeLibraryWrapper $navbarHeight={navbarHeight}>
          <CreativeLibraryPanel onClose={onClose} intent={PanelIntent.Select} onSelect={onSelect} />
        </CreativeLibraryWrapper>
      )}
      <SecondaryButton onClick={onClick} data-test="image-picker-button">
        <Image16 isColorInherited />
        {t('contentPicker.image')}
      </SecondaryButton>
    </div>
  );
};
